import { useEffect, useMemo } from "react"
import { markContactReplyThreadMessageAsRead } from "src/apis/contact/markContactReplyThreadMessageAsRead"
import { useAsyncSelector } from "src/hooks/useAsyncSelector"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"

type Param = {
  replyThreadMessageId: string
  isRead: boolean
  itemType?: string
  organizationId?: string
}

export const useMarkThreadMessageAsRead = ({ replyThreadMessageId, isRead, itemType }: Param) => {
  const { value: tokens } = useAsyncSelector(tokensState)
  const accessToken = useMemo(() => tokens?.accessToken, [tokens])

  useEffect(() => {
    if (itemType === "RemovedReply") {
      if (accessToken) {
        if (replyThreadMessageId) {
          markContactReplyThreadMessageAsRead({ accessToken, replyThreadMessageId })
        }
      }
    } else {
      if (accessToken && !isRead) {
        markContactReplyThreadMessageAsRead({ accessToken, replyThreadMessageId })
      }
    }
  }, [accessToken, isRead, replyThreadMessageId, itemType])
}
